import styled from 'styled-components'

import { Layout, Link, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import ImageEDI from '../../assets/tracking-onboarding-finalize-connection-api-edi.png'
import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

const StyledListItem = styled.li`
  padding-bottom: ${getToken('spacing-2')};
  list-style: decimal;
`

export default function APIFinalizeConnectionContent() {
  const { hasPreviousTracking } = useTrackingOnboardingContext()

  if (hasPreviousTracking) {
    return (
      <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md-bold">API integration with Project44</Text>
          <Layout.Stack gap="spacing-6">
            <Text variant="body-md">
              You're about to confirm your preferred connection as Project44 API.
            </Text>
            <Text variant="body-md">You can update this choice anytime via the tracking card.</Text>
          </Layout.Stack>
        </Layout.Stack>
        <img src={ImageEDI} alt="" width={285} height={175} />
      </Layout.Group>
    )
  }

  return (
    <Layout.Group style={{ flexWrap: 'nowrap' }} gap="spacing-12">
      <Layout.Stack gap="spacing-4">
        <Text variant="body-md-bold">Let this with our specialists</Text>
        <Text variant="body-md">
          To integrate with Project44 API you need to reach out to a Loadsmart specialist to guide
          you through this process. Follow these steps:
        </Text>
        <Layout.Group paddingL="spacing-4">
          <Text variant="body-md">
            <ol>
              <StyledListItem>
                Send an email to
                {
                  <Link href="mailto:solutions@loadsmart.com" aria-label="email link">
                    solutions@loadsmart.com
                  </Link>
                }{' '}
                with your MC and DOT numbers
              </StyledListItem>
              <StyledListItem>
                We will analyze the information and reach out to you to move forward through email
              </StyledListItem>
              <StyledListItem>
                The integration process will start and we will be in touch with you to confirm it is
                working
              </StyledListItem>
            </ol>
          </Text>
        </Layout.Group>
      </Layout.Stack>
      <img src={ImageEDI} alt="" width={285} height={175} />
    </Layout.Group>
  )
}
